import {Component, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TimeBetweenPipe} from '../../../shared/timeBetween.pipe';
import {NgForm} from '@angular/forms';
import {TasksService} from '../tasks.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UploadService} from '../../../../jobboard/shared/upload.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-task-view',
    templateUrl: './task-view.component.html',
    styleUrls: ['./task-view.component.scss']
})
export class TaskViewComponent implements OnInit, OnChanges  {
    @Input() tasks;
    @Input() sectionLabel;
    @Input() type;
    previewTask: any;
    taskStatus = 'Nou';
    isCollapsed = true;
    taskId: string;
    doneTasks = [];
    otherTasks = [];
    receiverName;
    senderName;
    taskAttachment: File = null;
    attachmentUploaded: Observable<any>;
    showLoader = false;
    formResponse: boolean;
    formSent: boolean;
    deleteAttachment = false;

    constructor(private tasksService: TasksService,
                private snackBar: MatSnackBar,
                private uploadService: UploadService) {

        this.uploadService.uploadFileSubject.subscribe(fileUploaded => {
            if (fileUploaded) {
                this.tasksService.getTaskById(this.previewTask.id, this.type).subscribe(previewTask => {
                    this.previewTask = previewTask;
                    this.showLoader = false;

                    this.snackBar.open('Fisier incarcat cu succes', 'Ok', {
                        duration: 2000,
                    })
                })
            } else {
                this.snackBar.open('A aparut o eroare la incarcare', 'Ok', {
                    duration: 2000,
                })

                this.showLoader = false;
            }
        });

    }

    ngOnChanges(changes: SimpleChanges) {
        this.initializeTasks();
    }

    ngOnInit(): void {
        this.initializeTasks();

        if (this.tasksAvailable('other')) {
            this.setCurrentTask(this.otherTasks[0].id, 'other');
        } else if (this.tasksAvailable('done')) {
            this.setCurrentTask(this.doneTasks[0].id, 'done');
        }
        console.log(this.previewTask.senderUserId, 'senderId')
        this.tasksService.getUserCrm(this.previewTask.senderUserId).subscribe(user => {
            this.senderName = user['name'];
            console.log(this.senderName, 'sender', user['name'], user);
        })

        this.tasksService.getUserCrm(this.previewTask.receiverUserId).subscribe(user => {
            this.receiverName = user['name'];
            console.log(this.receiverName, 'receiver', user['name'], user);
        })
    }

    initializeTasks() {
        if (this.type === 'pdp') {
            this.doneTasks = this.tasks.donePlans;
            this.otherTasks = this.tasks.otherPlans;
        } else {
            this.doneTasks = this.tasks.doneTasks;
            this.otherTasks = this.tasks.otherTasks;
        }
    }

    setCurrentTask(id, type) {

        if (type === 'done') {
            this.previewTask = this.doneTasks.filter(currentTaskLoop => {
                    if (currentTaskLoop.id === id) {
                        return currentTaskLoop;
                    }
                }
            )[0];
        } else if (type === 'other') {
            this.previewTask = this.otherTasks.filter(currentTaskLoop => {
                    if (currentTaskLoop.id === id) {
                        return currentTaskLoop;
                    }
                }
            )[0];
        }
    }


    tasksAvailable(type) {
        if (type === 'done' && this.doneTasks.length >= 1) {
            return true;
        } else return type === 'other' && this.otherTasks.length >= 1;
    }

    onChangeStatus(newStatus, task) {
        this.tasksService.changeTaskStatus(this.previewTask.id, newStatus.value, this.type).subscribe(res => {
            if (res) {
                if (newStatus.value === 'Done') {
                    this.otherTasks = this.otherTasks.filter(item => item.id !== task.id);
                    this.doneTasks.push(task);
                } else {
                    this.otherTasks = this.otherTasks.filter(item => item.id !== task.id);
                    this.doneTasks = this.doneTasks.filter(item => item.id !== task.id);
                    this.otherTasks.push(task);
                }

                this.snackBar.open('Status setat', 'Ok', {
                    duration: 2000,
                })
            }
        })
    }
    deleteFile(index: number){
        this.previewTask.attachments.splice(index, 1)
        this.tasksService.updateTask(this.previewTask, this.previewTask.id, this.type).subscribe(previewTask => {
            console.log(previewTask, 'response?')
        }, error => {
            this.formResponse = false;
            this.deleteAttachment = true;
            setTimeout(() => {
                this.deleteAttachment = false;
            }, 4000);

        })
    }

    uploadTaskAttachment(e) {
        this.showLoader = true;
        this.taskAttachment = e.target.files;
        if (this.type === 'pdp') {
            this.uploadService.upload(this.taskAttachment, '/crm/uploadPDPAttachment?personalDevelopmentId=' + this.previewTask.id);
        } else {
            this.uploadService.upload(this.taskAttachment, '/crm/uploadTaskAttachment?taskId=' + this.previewTask.id);
        }
    }


    sendMessage(messageForm: NgForm) {
        const message = messageForm.value.message;
        if (messageForm.valid) {
            this.tasksService.respondToTask(this.previewTask.id, message, this.type).subscribe(res => {
                if (res['success']) {
                    this.formResponse = true;
                    this.formSent = true;
                    setTimeout(() => {
                        this.formSent = false;
                    }, 4000);

                    this.tasksService.getTaskById(this.previewTask.id, this.type).subscribe(task => {
                        this.previewTask = task;
                        messageForm.resetForm();
                    })
                } else {
                    this.formResponse = false;
                    this.formSent = true;
                    setTimeout(() => {
                        this.formSent = false;
                    }, 4000);

                }
                }, error => {
                this.formResponse = false;
                this.formSent = true;
                setTimeout(() => {
                    this.formSent = false;
                }, 4000);

            })
        } else {
            this.formResponse = false;
            this.formSent = true;
            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        }


    }
}
